 
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';

import { CredentialsService } from '@core/utils';
import { AlertService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private credentialsService = inject(CredentialsService);
  private alertService = inject(AlertService);
  private router = inject(Router);

  launchError(error: HttpErrorResponse) {
    // console.log('launchError', error.status);

    const alertContent = this.alertType(error.status);

    if (error.status === 0) {
      this.alertService.showMessage({
        ...alertContent,
        text: error?.error?.systemMessage || 'Ops!, Se ha presentado un inconveniente, vuelva a ingresar a la plataforma',
      });
      //this.logout();
      return;
    }

    if (error.status === 401) {
      this.alertService.showMessage({
        ...alertContent,
        title: 'Sesión expirada',
        text: error?.error?.systemMessage || 'Su sesión ha expirado, ingrese nuevamente.',
      });
      this.logout();
      return;
    }

    if (error.status === 400) {
      this.alertService.showMessage({
        ...alertContent,
        title: 'Información Incorrecta',
        text: error?.error?.systemMessage || 'Usuario o Contraseña Incorrecta',
      });
      //this.logout();
      return;
    }

    if (error.status === 404) {
      this.alertService.showMessage({
        ...alertContent,
        text: error?.error?.systemMessage || 'Recurso no encontrado',
      });
      //this.logout();
      return;
    }

    if (error.status === 406) {
      this.alertService.showMessage({
        ...alertContent,
        text: error?.error?.systemMessage || 'Ocurrió un problema al procesar la solicitud',
      });
      return;
    }

    if (error.status === 500 && error?.error) {
      if (error.error?.errorCode === 'ACCESS') {
        this.router.navigateByUrl('/', { replaceUrl: true });
      }

      this.alertService.showMessage({
        ...alertContent,
        text: error?.error?.systemMessage || 'Error interno',
      });
      return;
    }

    if (error.status > 500) {
      this.alertService.showMessage({
        ...alertContent,
        text: error?.error?.systemMessage || 'Se ha presentado un inconveniente, vuelva a ingresar a la plataforma',
      });
      //this.logout();
      return;
    }

    if (error.error && error.error.systemMessage) {
      this.alertService.showMessage({
        ...alertContent,
        text: error?.error?.systemMessage || '',
      });
    }
  }

  alertType(status: number) {
    const errorObj = { title: 'Error', icon: 'cancel', class: 'text-danger' };
    const warningObj = {
      title: 'Advertencia',
      icon: 'brightness_alert',
      class: 'text-warning',
    };

    const errorCodes = [0, 204, 404, 503];
    const warningCodes = [400, 401, 500, 403, 406];

    if (errorCodes.includes(status)) {
      return errorObj;
    }

    if (warningCodes.includes(status)) {
      return warningObj;
    }

    return errorObj;
  }

  logout() {
    // Customize credentials invalidation here
    this.credentialsService.setCredentials();
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }
}
